/**
 * As per Sentry's documentation[1] this should always be imported first to
 * ensure we initialise the Sentry SDK as early as possible.
 *
 * [1]: https://docs.sentry.io/platforms/javascript/guides/react/#configure
 */
import "./instrument";
import "core-js";
import "regenerator-runtime/runtime";

/**
 * This is required by the iframe-resizer parent (wherever this app is
 * embedded, e.g. Appointedd) to be able to auto-resize the iframe this app
 * runs in. It's a side-effect-only script: it just wires up postMessage
 * listeners against the content window, so importing it here for its side
 * effects is all that's needed to get it bundled with the app.
 *
 * Any change to the "iframe-resizer" dependency's version may change this
 * file path — webpack will throw a module-not-found error if so, and the
 * path will need updating to match.
 */
import "iframe-resizer/js/iframeResizer.contentWindow.min.js";
import { App } from "./App";
import React from "react";
import ReactDOM from "react-dom";
ReactDOM.render(<App />, document.getElementById("main"));